import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import setExpirationDate from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/SetExpirationDate";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import { RfqQuoteDetailsPageContext } from "@insite/content-library/Pages/RfqQuoteDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    quoteState: getQuoteState(state, state.pages.rfqQuoteDetails.quoteId),
});

const mapDispatchToProps = {
    setExpirationDate,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface rfqQuoteDetailTermsAndConditionStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    quoteTermsCondition?: TypographyProps;
}

export const rfqQuoteDetailTermsAndConditionStyles: rfqQuoteDetailTermsAndConditionStyles = {
    wrapper: {
        css: css`
            padding-bottom: .625rem;
            font-family: 'Lato',sans-serif;
            font-size: 1rem;
            letter-spacing: 0.5px;
            line-height: 1.5rem;
        `,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            @media print {
                font-size: .75rem;
            }
            margin-bottom: 1.25rem;
            color: ${themeColors.colorPrimary};
            font-size: 1rem;
            line height: 1.5rem;
            font-family: 'Roboto', sans-serif;
            font-weight: ${themeFontWeights.fontWeightForBold};
            letter-spacing: 0.5px;           
            &:after {
               
                display: inline-block;
            }
        `,
    },
    quoteTermsCondition: {
        css: css`
            color: #333F48;
            font-size: 1rem;
            line height: 1.5rem;
            letter-spacing: 0.5px; 
            font-family: 'Lato',sans-serif;
    `,
    },
    
};

const styles = rfqQuoteDetailTermsAndConditionStyles;

const RfqQuoteDetailTermsAndCondition = ({
    quoteState,
}: Props) => {
    const quote = quoteState.value;

    if (!quote) {
        return null;
    }

    return (
       
        <StyledWrapper {...styles.wrapper} data-test-selector="rfqQuoteDetailsTermsAndCondition" className="quoteNotesGrid">
            <Typography {...styles.titleText} id="quoteTermsCond">
                        {translate("Terms & Conditions for this transaction")}
                    </Typography>

                    <Typography {...styles.quoteTermsCondition} aria-labelledby="quoteTermsCond">
                        {siteMessage("Quote_Details_Terms_And_Condition")}
                    </Typography>
        </StyledWrapper>        

    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RfqQuoteDetailTermsAndCondition),
    definition: {
        displayName: "Quote Detail Terms And Condition",
        fieldDefinitions: [],
        group: "RFQ Quote Details",
    },
};

export default widgetModule;
